import React, { useState, useEffect } from "react";
import FranchiseStyle from "./FranchiseStyle";
import FranchiseTheme from "./FranchiseTheme";
import { ApplicationDataAPI } from "../../API/ApplicationDataAPI";
import { ThemeProvider } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";

export default function FranchiseInfo({ app }) {
	const classes = FranchiseStyle();
	const [application, setApplication] = useState({});
	const [assets, setAssets] = useState([]);
	const [corporateGuarantors, setCorporateGuarantors] = useState([]);
	const [error, setError] = useState({
		status: false,
		loading: false,
		isSaved: false,
		message: "",
	});
	const [isLoading, setIsLoading] = useState(true);
	useEffect(() => {
		(async () => {
			try {
				setIsLoading(true);

				const response = await Promise.allSettled([
					ApplicationDataAPI.fetchApplicationById(app.id, app.broker_id, app.locked_by_email),
					ApplicationDataAPI.fetchApplicationGuarantorsById(app.id, app.broker_id, app.locked_by_email),
					ApplicationDataAPI.fetchApplicationAssetsById(app.id, app.broker_id, app.locked_by_email),
				]);

				const appResponse =
					response[0].status === "fulfilled" ? response[0].value : {};
				const guarantorResponse =
					response[1].status === "fulfilled" ? response[1].value : [];
				const assetsResponse =
					response[2].status === "fulfilled" ? response[2].value : [];
				const corpGuarantors = guarantorResponse?.filter(
					(item) => item.is_corporate_guarantor
				);

				setApplication(appResponse);
				setCorporateGuarantors(corpGuarantors);
				setAssets(assetsResponse);
			} catch (err) {
				setError({ ...error, status: true, message: err.message });
			} finally {
				setIsLoading(false);
			}
		})();
	}, [app]);

	const handleCheckboxChange = (field) => (e) => {
		setApplication({ ...application, [field]: e.target.checked });
	};

	const handleFieldChange = (field) => (e) => {
		setApplication({ ...application, [field]: e.target.value });
	};

	const handleSave = async () => {
		const check =
			application?.franchise_purchase ||
			application?.franchise_remodel ||
			application?.franchise_cashout ||
			application?.franchise_refi;
		if (!check)
			setError({
				...error,
				status: true,
				message: "Purchase/Remodel/Cashout/Refi Atleast one needs to be selected",
			});
		else {
			console.log("saving franchise data!");
			try {
				setError({ ...error, loading: true });
				await ApplicationDataAPI.updateApplication(
					application,
					application.broker_id,
					application.locked_by_email
				);
				setError({
					...error,
					status: false,
					loading: false,
					isSaved: true,
					message: "Franchise data saved successfully.",
				});
			} catch (err) {
				setError({
					...error,
					status: true,
					isSaved: false,
					loading: false,
					message: err.message,
				});
			}
		}
	};
	console.log("Najib checking arr", corporateGuarantors);
	const setDefaultFirstLienInfo = () => {
		let defaultFirstLienInfo = `North Mill Credit Trust is to be granted a perfected first position blanket lien on ${application?.franchisor_name} located at ${application?.address}, ${application?.city}, ${application?.state}, ${application?.zip_code}`;
		return defaultFirstLienInfo;
	};

	const setDefaultSecondLienInfo = () => {
		let defaultSecondLienInfo = `North Mill Credit Trust is to be granted a perfected second position blanket lien on ${application?.franchisor_name} located at ${application?.address}, ${application?.city}, ${application?.state}, ${application?.zip_code}`;
		return defaultSecondLienInfo;
	};

	const setDefaultEquipmentLienInfo = () => {
		if (assets?.length > 0) {
			let highestValue = 0.0;
			let highestValueAsset = null;
			let processedAssets = assets?.forEach((item) => {
				let value = item.nmef_equipment_value;
				if (value > highestValue || highestValueAsset === null) {
					highestValueAsset = item;
					highestValue = value;
				}
			});
			let defaultEquipmentLienInfo = `North Mill Credit Trust is to granted a perfected lien on ${highestValueAsset
				? highestValueAsset.override_description
					? highestValueAsset.override_description
					: highestValueAsset.description
				: null
				}`;
			return defaultEquipmentLienInfo;
		}
	};

	return (
		<ThemeProvider theme={FranchiseTheme}>
			{isLoading && (
				<Box className={classes.circularProgress}>
					<CircularProgress />
				</Box>
			)}

			{!isLoading && (
				<Box className={classes.root}>
					<Grid container spacing={2} style={{ marginBottom: "15px" }}>
						<Grid item xs={6} style={{ borderRight: "2px solid #000000" }}>
							<FormControlLabel
								style={{ marginLeft: "0" }}
								checked={true}
								disabled
								control={<Checkbox color="primary" size="small" />}
								label="IS Franchise"
								labelPlacement="start"
							/>
							<Box className={classes.textGroup}>
								<Typography variant="subtitle2" style={{ marginRight: "10px" }}>
									Type Of Franchise:
								</Typography>
								<TextField value={application?.franchise_type} disabled />
							</Box>
							<Box className={classes.textGroup}>
								<Typography variant="subtitle2" style={{ marginRight: "10px" }}>
									Name Of Franchisor:
								</Typography>
								<TextField value={application?.franchisor_name} disabled />
							</Box>
						</Grid>
						<Grid item xs={6}>
							<FormGroup aria-label="position" style={{ float: "left" }}>
								<FormControlLabel
									label="Purchase"
									labelPlacement="start"
									checked={application?.franchise_purchase}
									onChange={handleCheckboxChange("franchise_purchase")}
									control={<Checkbox color="primary" size="small" />}
								/>
								<FormControlLabel
									label="Remodel"
									labelPlacement="start"
									checked={application?.franchise_remodel}
									onChange={handleCheckboxChange("franchise_remodel")}
									control={<Checkbox color="primary" size="small" />}
								/>
								<FormControlLabel
									label="Cashout"
									labelPlacement="start"
									checked={application?.franchise_cashout}
									onChange={handleCheckboxChange("franchise_cashout")}
									control={<Checkbox color="primary" size="small" />}
								/>
								<FormControlLabel
									label="Refi"
									labelPlacement="start"
									checked={application?.franchise_refi}
									onChange={handleCheckboxChange("franchise_refi")}
									control={<Checkbox color="primary" size="small" />}
								/>
							</FormGroup>
						</Grid>
					</Grid>
					<Grid>
						<Table
							size="small"
							className={classes.table}
							aria-label="franchise table">
							<TableHead className={classes.head}>
								<TableRow>
									<TableCell style={{ width: "10px" }}></TableCell>
									<TableCell style={{ width: "220px" }}>Type</TableCell>
									<TableCell>Description</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell>
										<Checkbox
											size="small"
											color="primary"
											checked={application?.franchise_first_lien}
											onChange={handleCheckboxChange("franchise_first_lien")}
										/>
									</TableCell>
									<TableCell>First Position Blanket Lien</TableCell>
									<TableCell>
										<TextField
											fullWidth={true}
											multiline
											rows={2}
											variant="outlined"
											value={
												application?.franchise_first_lien_info
													? application?.franchise_first_lien_info
													: setDefaultFirstLienInfo()
											}
											onChange={handleFieldChange("franchise_first_lien_info")}
										/>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										<Checkbox
											size="small"
											color="primary"
											checked={application?.franchise_second_lien}
											onChange={handleCheckboxChange("franchise_second_lien")}
										/>
									</TableCell>
									<TableCell>Second Position Blanket Lien</TableCell>
									<TableCell>
										<TextField
											fullWidth={true}
											multiline
											rows={2}
											variant="outlined"
											value={
												application?.franchise_second_lien_info
													? application?.franchise_second_lien_info
													: setDefaultSecondLienInfo()
											}
											onChange={handleFieldChange("franchise_second_lien_info")}
										/>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										<Checkbox
											size="small"
											color="primary"
											checked={application?.franchise_equipment_lien}
											onChange={handleCheckboxChange("franchise_equipment_lien")}
										/>
									</TableCell>
									<TableCell>Equipment Lien</TableCell>
									<TableCell>
										<TextField
											fullWidth={true}
											multiline
											rows={2}
											variant="outlined"
											value={
												application?.franchise_equipment_lien_info
													? application?.franchise_equipment_lien_info
													: setDefaultEquipmentLienInfo()
											}
											onChange={handleFieldChange("franchise_equipment_lien_info")}
										/>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</Grid>

					<Grid style={{ marginTop: "10px" }}>
						<FormControlLabel
							label="Cross corp guaranty"
							labelPlacement="start"
							style={{ marginLeft: "0" }}
							checked={corporateGuarantors?.length > 0}
							disabled
							control={<Checkbox color="primary" size="small" />}
						/>
					</Grid>
					{corporateGuarantors?.length > 0 && (
						<Grid>
							<Typography variant="subtitle2">Corporate Guarantor Info :</Typography>
							<Table
								size="small"
								className={classes.table}
								aria-label="franchise table 2">
								<TableHead className={classes.head}>
									<TableRow>
										<TableCell>Name</TableCell>
										<TableCell>FEIN</TableCell>
										<TableCell>Address</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{corporateGuarantors.map(
										(item) => (
											<TableRow>
												<TableCell>
													{item?.guarantor?.first_name} {item?.guarantor?.last_name}
												</TableCell>
												<TableCell>{item?.federal_id_number}</TableCell>
												<TableCell>
													{item?.guarantor?.street}, {item?.guarantor?.city},{" "}
													{item?.guarantor?.zip_code}, {item?.guarantor?.state},{" "}
													{item?.guarantor?.country}
												</TableCell>
											</TableRow>
										)
									)}
								</TableBody>
							</Table>
						</Grid>
					)}

					<Grid container style={{ marginTop: "1rem" }}>
						<Grid item>
							<Table
								size="small"
								className={classes.table2}
								aria-label="franchise table 3">
								<TableBody>
									<TableRow>
										<TableCell style={{ paddingLeft: "0" }}>
											Number of unit owned by Guarantor:{" "}
										</TableCell>
										<TableCell>
											<TextField
												type="number"
												variant="outlined"
												value={application?.franchise_unit_owned_by_guarantor}
												onChange={handleFieldChange("franchise_unit_owned_by_guarantor")}
											/>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell style={{ paddingLeft: "0" }}>
											Number of unit secured by first lien by NMEF:
										</TableCell>
										<TableCell>
											<TextField
												type="number"
												variant="outlined"
												value={application?.franchise_unit_secured_by_nmef}
												onChange={handleFieldChange("franchise_unit_secured_by_nmef")}
											/>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell style={{ paddingLeft: "0" }}>
											Number of unit cross corp guaranteed:
										</TableCell>
										<TableCell>
											<TextField
												type="number"
												variant="outlined"
												value={application?.franchise_unit_cross_corp}
												onChange={handleFieldChange("franchise_unit_cross_corp")}
											/>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</Grid>
						<Grid item></Grid>
					</Grid>

					{error.loading && (
						<Grid>
							<LinearProgress />
						</Grid>
					)}

					{!error.loading && (error.status || error.isSaved) && (
						<Grid>
							<Alert
								severity={error.status ? "error" : "success"}
								onClose={() =>
									setError({
										...error,
										status: false,
										isSaved: false,
										message: "",
									})
								}>
								{error.message}
							</Alert>
						</Grid>
					)}
					<Grid style={{ textAlign: "center", marginTop: "1rem" }}>
						<Button
							variant="contained"
							color="primary"
							disableElevation={true}
							onClick={handleSave}>
							Save Info
						</Button>
					</Grid>
				</Box>
			)}
		</ThemeProvider>
	);
}
